var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"manage-agency-title"},[_vm._v(" Organization Chart > จัดการหน่วยงาน ")])
}
var staticRenderFns = []

export { render, staticRenderFns }